import { render, staticRenderFns } from "./HtmlEditor.vue?vue&type=template&id=11863050&scoped=true&"
import script from "./HtmlEditor.vue?vue&type=script&lang=ts&"
export * from "./HtmlEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11863050",
  null
  
)

export default component.exports